export default __webpack_public_path__ + "static/media/discord-circ.a97dc154.svg";